import { render } from "./AddInboxes.vue?vue&type=template&id=6d3a748c"
import script from "./AddInboxes.vue?vue&type=script&lang=js"
export * from "./AddInboxes.vue?vue&type=script&lang=js"

import "./AddInboxes.vue?vue&type=style&index=0&id=6d3a748c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__